import React from 'react';
import logo from '../images/logo.png';
import playstoreLogo from "../../assets/images/playstore.png";
import appstoreLogo from "../../assets/images/appstore.svg";
import {
  MDBBtn,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBRow,
  MDBCol,
  MDBInput
}
  from 'mdb-react-ui-kit';
import Footer from './Footer';
import './LoginContainer.css';
import { connect } from 'react-redux';
import Loader from '../../Loader';
import { baseURL } from '../../api/baseURL';
import axios from 'axios';
import Modal from '../../Modal';


type State = {
  requested: boolean,
  err: any,
  email: string,
  password: string,
  emailError: boolean,
  showPassword: boolean
};

class LoginContainer extends React.Component<{ dispatch: any, history: any, token: string }> {

  state: State = {
    requested: false,
    err: false,
    email: "",
    password: "",
    emailError: false,
    showPassword: false
  }

  componentDidMount = () => {
    if (this.props.token) {
      window.location.pathname = "/dashboard";
    }
  }

  onSignIn = () => {
    if (this.state.email && this.state.password) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      const email = (this.state.email || "").trim();
      if (emailRegex.test(email)) {
        //Valid
      }
      else {
        //Invalid
        this.setState({ emailError: true });
        return;
      }

      if (!this.state.requested) {
        this.setState({ err: false, requested: true });
        axios.post(`${baseURL}/login`,
          {
            email: this.state.email,
            password: this.state.password
          })
          .then((response: any) => {
          //console.log(response);
            if (response?.data?.token) {
              this.props.dispatch({ type: "SIGN_IN", payload: response });
              window.location.pathname = "/dashboard";
            }
            else {
              this.setState({ err: true, requested: false });
            }
          })
          .catch((error: any) => {
          //console.log(error);
            if (error?.response?.data === "Invalid Email") {
              this.setState({ err: "email", requested: false });
            }
            else if (error?.response?.data === "Invalid Password") {
              this.setState({ err: "password", requested: false });
            }
            else {
              this.setState({ err: true, requested: false });
            }
          })
      }
    }
  }

  toggleModal = () => {
    if (this.state.emailError) {
      this.setState({ emailError: false });
    }

    if (this.state.err) {
      this.setState({ err: false });
    }
  }

  render() {
  //console.log(this.state)
    return (
      <>
        <Modal open={this.state.emailError || this.state.err} hideSec primaryText="Okay" title='Update'
          onConfirm={this.toggleModal} toggleOpen={this.toggleModal}
          content={
            <h6>
              {!this.state.emailError ? this.state.err === "email" ? "Your email is incorrect" :
                this.state.err === "password" ? "Your password is incorrect" :
                  "Something went wrong, please try again later" : "Your email is not valid"}
            </h6>}
        />
        {this.state.requested ? <Loader /> : null}
        <MDBContainer className="my-5">
          <div style={{ boxShadow: 'rgba(0, 0, 0, 0.07) 0px 2px 15px -3px, rgba(0, 0, 0, 0.04) 0px 10px 20px -2px', padding: '0 30px' }}>
            <MDBRow style={{ justifyContent: 'center' }} className='g-0'>
              {document.documentElement.clientWidth < 1100 ? null : <MDBCol style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '75vh' }} md='5'>
                <MDBCardImage src={logo} style={{ width: '300px' }} alt="login form" className='rounded-start' />
              </MDBCol>}
              <MDBCol md='5' style={{ margin: 'auto 0' }}>
                <MDBCardBody className='d-flex flex-column'>
                  <div className='d-flex flex-row mt-2'>
                    <span style={{ color: 'black' }} className="h1 fw-bold mb-0">SnapWiz</span>
                  </div>
                  <h5 className="fw-normal my-4 pb-3" style={{ letterSpacing: '1px', color: 'black' }}>Sign into your account</h5>
                  <MDBInput wrapperClass='mb-4' label='Email address' className='customFormInput' id='formControlLg' type='email' size="lg" style={{ color: "#171717" }} onChange={(e) => { this.setState({ email: e?.target?.value }); }} />
                  <div style={{ position: 'relative' }}>
                    <MDBInput
                      wrapperClass='mb-4'
                      label='Password'
                      className='customFormInput'
                      id='formControlLg'
                      type={this.state.showPassword ? 'text' : 'password'}
                      size="lg"
                      style={{ color: "#171717", paddingRight: 44 }}
                      onChange={(e) => { this.setState({ password: e?.target?.value }); }}
                    />
                    <button
                      type="button"
                      onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                      aria-label={this.state.showPassword ? 'Hide password' : 'Show password'}
                      title={this.state.showPassword ? 'Hide password' : 'Show password'}
                      style={{
                        position: 'absolute',
                        // Sits inside the input on the right; vertically centered
                        // ignoring the .mb-4 bottom margin so it stays aligned.
                        top: 'calc(50% - 12px)',
                        right: 12,
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        padding: 4,
                        cursor: 'pointer',
                        color: '#6c757d',
                        lineHeight: 0,
                      }}
                    >
                      {/* Switched from MDBIcon (Font Awesome) to MDI — Font Awesome isn't bundled
                          in this app, so `fas icon="eye"` was rendering as a fallback glyph
                          (horizontal lines). MDI is already loaded globally. */}
                      <i
                        className={`mdi ${this.state.showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'}`}
                        style={{ fontSize: 20, color: '#6c757d', lineHeight: 1 }}
                      />
                    </button>
                  </div>
                  <MDBBtn style={{ padding: '15px 0' }} className="mb-4 px-5" color='dark' size='lg' onClick={() => [this.onSignIn()]}>Login</MDBBtn>
                  <div className="d-flex flex-row align-items-center mt-2 gap-2 mb-4" style={{ flexWrap: 'wrap', justifyContent: document.documentElement.clientWidth < 1100 ? 'center' : 'left' }}>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.photographycustomer"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={playstoreLogo}
                        alt="Get it on Google Play"
                        style={{ width: '150px', height: '50px', borderRadius: 10 }}
                      />
                    </a>
                    <a
                      href="https://apps.apple.com/in/app/snapwiz/id6738880966"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={appstoreLogo}
                        alt="Download on the App Store"
                        style={{ width: '150px', height: '50px', borderRadius: 10 }}
                      />
                    </a>
                  </div>
                </MDBCardBody>
              </MDBCol>
            </MDBRow>
          </div>
        </MDBContainer>
        <Footer />
      </>
    )
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
